<div class="information-page">
  <section class="information-shell">
    <div class="information-copy">
      <h1 class="information-title">{{ 'TRANSLATE.WELCOME.TO.THE.INFORMATION.PAGE' | translate }}</h1>

      <p class="information-lead">{{ 'TRANSLATE.INFORMATION.GUIDE' | translate }}</p>

      <ul class="information-list">
        <li>{{ 'TRANSLATE.ACCESSING.THE.SYSTEM' | translate }}</li>
        <li>{{ 'TRANSLATE.GENERATING.A.CONTRACT.GUIDE' | translate }}</li>
        <li>{{ 'TRANSLATE.INFORMATION.ABOUT.EXTENDED.WARRANTY' | translate }}</li>
      </ul>

      @if (systemCountry === 'BRA') {
        <div class="information-actions">
          <button
            id="btnDownloadBra"
            class="action-button app-primary-button system-guide-button"
            type="button"
            (click)="downloadPdfBra()"
            [disabled]="isDownloadingGuide"
            [attr.aria-busy]="isDownloadingGuide">
            @if (!isDownloadingGuide) {
              <i class="pi pi-download" aria-hidden="true"></i>
            }
            @if (isDownloadingGuide) {
              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            }
            <span class="action-button-label">
              {{ (isDownloadingGuide ? 'TRANSLATE.DOWNLOADING.SYSTEM.GUIDE' : 'TRANSLATE.SYSTEM.GUIDE') | translate }}
            </span>
          </button>
        </div>
      }

      @if (systemCountry === 'ARG') {
        <div class="information-actions">
          <button
            id="btnDownloadArg"
            class="action-button app-primary-button system-guide-button"
            type="button"
            (click)="downloadPdfArg()"
            [disabled]="isDownloadingGuide"
            [attr.aria-busy]="isDownloadingGuide">
            @if (!isDownloadingGuide) {
              <i class="pi pi-download" aria-hidden="true"></i>
            }
            @if (isDownloadingGuide) {
              <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
            }
            <span class="action-button-label">
              {{ (isDownloadingGuide ? 'TRANSLATE.DOWNLOADING.SYSTEM.GUIDE' : 'TRANSLATE.SYSTEM.GUIDE') | translate }}
            </span>
          </button>
        </div>
      }

      @if (systemCountry === 'BRA') {
        <p class="information-footer">
          {{ 'TRANSLATE.ACCESS.THE.PORTAL' | translate }}
          <a
            class="information-link"
            href="https://www.atfmcdealer.dealerconnection.com/sites/Brasil/Pecas%20e%20Servicos/FordProtect/Pages/default.aspx"
            rel="noopener noreferrer"
            target="_blank">
            {{ 'TRANSLATE.FMC.DEALER' | translate }}
          </a>
        </p>
      }
    </div>

    <figure class="information-visual" aria-hidden="true">
      <img src="../../../assets/image/information_page.png" alt="" class="information-image">
    </figure>
  </section>
</div>